/* unplugin-vue-components disabled */
import {ShCompanies} from 'stores/sh-companies'

export default {
  mixins: [ModelValue(Array)],
  data() {
    return {
      loading: true,
      options: undefined,
      // we do not use default store here to allow this control to be used multiple times
      // on the same page or on another pages with the default store
      store: new ShCompanies()
    }
  },
  async mounted() {
    if (this.value) {
      const options = []
      await this.store.load({ids: this.value})      
      for(const company of this.store.view_items) {
        let label = company.name
        if (company.linkedin_id)
          label += ` [${company.linkedin_id}]`
        options.push({
          value: company.id,
          label: label
        })
      }
      this.options = options
    }
    this.loading = false
  },
  methods: {
    async searchShCompanies(autocomplete) {
      await this.store.load({autocomplete, limit: 50})
      this.options = this.store.view_items.map(company => {
        let label = company.name
        if (company.linkedin_id)
          label += ` [${company.linkedin_id}]`
        return {
          value: company.id,
          label: label
        }
      })
    }
  }
}
